import { Component } from '@angular/core';

@Component({
  selector: 'app-repository',
  templateUrl: './repository.component.html',
  styleUrl: './repository.component.scss'
})
export class RepositoryComponent {
  bodySpinner:boolean=false;
  contractList:any=[];
  repositoryList:any=[];
  botEnabled:boolean=false;
  searchText:any;
  expandEnabled:boolean=false;
  constructor(){
      this.contractList=[
      {
        "contract_type":"ABC Inc"
      },
      {
        "contract_type":"Matrix"
      },
      {
        "contract_type":"ACInfo tech"
      }
    ];
    this.repositoryList=[
      {
        "company_name":"Food Inc",
        "contract_type":"NDA",
        "efftectdate":"01/25/2026",
        "terminateperiod":"2",
        "terminatedate":"03/04/2028",
        "terminatenotice":"2",
        "terminatenoticeperiod":"1.5",
        "obligation":"",
        "status":"Executed",
        "summary":"",
        "version":"1",
        "assigned":"Jhon"
      },
        {
        "company_name":"Grocery",
        "contract_type":"ASA",
        "efftectdate":"01/04/2026",
        "terminateperiod":"2.5",
        "terminatedate":"03/04/2029",
        "terminatenotice":"3",
        "terminatenoticeperiod":"3",
         "obligation":"",
        "status":"Negotiation",
         "summary":"",
        "version":"2",
        "assigned":"David"
      },  {
        "company_name":"ACInfo tech",
        "contract_type":"DPA",
        "efftectdate":"01/15/2026",
        "terminateperiod":"2.5",
        "terminatedate":"04/04/2029",
        "terminatenotice":"3",
        "terminatenoticeperiod":"3",
         "obligation":"",
        "status":"Closed",
         "summary":"",
        "version":"1",
        "assigned":"Smith"
      },  {
        "company_name":"Vel Construction",
        "contract_type":"MSA",
        "efftectdate":"01/25/2026",
        "terminateperiod":"3",
        "terminatedate":"05/04/2030",
        "terminatenotice":"3",
        "terminatenoticeperiod":"3.5",
         "obligation":"",
        "status":"Renewal",
         "summary":"",
        "version":"2",
        "assigned":"Rosy"
      }
    ]
  }

 
  
 toggleBot(){
    this.botEnabled = !this.botEnabled;
  }
    expandPanel(){
    this.expandEnabled = !this.expandEnabled;
  }
}
